import React, { useState } from "react";
import * as Yup from "yup";
import { useAuth } from "../utility/auth";
import { Formik } from "formik";
import {
  Container,
  Grid,
  useTheme,
  Box,
  Stack,
  IconButton,
} from "@mui/material";
import Load from "../components/FormsUI/Loader/index";
import Controls from "../components/FormsUI";
import { downloadPDF } from "../utility/downloadPDF";
import PDF from "../assets/images/pdf_icon.png";
import SearchIcon from "@mui/icons-material/Search";
import PDFLoader from "../assets/images/loader.gif";
import FeeReceiptController from "../controller/FeeReceiptController";
import MasterController from "../controller/MastersController";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExceptionHandlerController from "../controller/ErrorLogsController";
import "../css/style.css";
import dayjs from "dayjs";
import moment from "moment";
import CustomizedSnackbars from "../components/Alert";
import { tokens } from "../theme";

const INITIAL_FORM_STATE = {
  memberName: "",
  email: "",
  mobileNumber: "",
  memberId: "",
  feePaidBy: "",
  feeYear: "",
  feefor: "",
  subfeefor: "",
  remarks: "",
  feeType: "",
  amount: "",
  selectedFeeType: null,
  feeYearSelected: null,
  selectedSubfeeforDD: null,
  selectedfeeforDD: null,
  paymentMode: "",
  selectedPaymentMode: null,
  chequeOrUTRNo: "",
  chequeDate: "",
  receiptDate: "",
};
const customDateValidation = (message, field) =>
  Yup.string().test("custom-validation", message, function (value) {
    let errorMessage = "";
    if (!value) {
      errorMessage = message;
      return this.createError({ path: field, message: errorMessage });
    }
    let dateRegEx = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegEx.test(value)) {
      errorMessage = "Invalid date";
      return this.createError({ path: field, message: errorMessage });
    }
    let date = value?.split("/");
    if (date[0] === "Invalid date") {
      errorMessage = "Invalid date";
      return this.createError({ path: field, message: errorMessage });
    }
    let formattedDate = new Date(
      Number(date[2]),
      Number(date[1] - 1),
      Number(date[0])
    );
    if (formattedDate > new Date()) {
      errorMessage = "Future dates are not allowed";
      return this.createError({ path: field, message: errorMessage });
    }

    return true;
  });

const FORM_VALIDATION = Yup.object({
  memberName: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .max(50, "Member Name must be at most 50 characters")
    .matches(
      /^[A-Z a-z]+$/,
      "Member Name must contain only alphabetic characters"
    )
    .required("Member name is required"),
  memberId: Yup.string().optional().trim(true),
  feefor: Yup.string().required("Fee for is required"),
  subfeefor: Yup.string().when("feefor", {
    is: process.env.REACT_APP_OTHERS_RECEIPT,
    then: Yup.string(),
    otherwise: Yup.string().required("Purpose is required"),
  }),
  feePaidBy: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .max(100, "Fee paid by must be at most 100 characters")
    .optional(),
  email: Yup.string()
    .email("Invalid email address")
    .trim("No white space allowed")
    .strict(true)
    .max(150, "E-mail must be at most 150 characters")
    .optional(),
  mobileNumber: Yup.string()
    .required("Mobile number is required")
    .trim("White space is not allowed")
    .strict(true)
    .max(10, "Mobile number should not excceed 10 character"),
  feeYear: Yup.string().required("Fee year is required"),
  feeType: Yup.string().optional(),
  remarks: Yup.string().optional().trim("No white space allowed").strict(true),
  paymentMode: Yup.string().required("Payment mode is required"),
  amount: Yup.string()
    .required("Amount is required")
    .trim("No white space allowed")
    .strict(true)
    .min(3, 'Minimum 3 digits are allowed')
    .max(10, 'Maximum 10 digits are allowed')
    .matches(/^\d{1,10}(\.\d{1,2})?$/, "Only numeric values are allowed"),
  chequeOrUTRNo: Yup.string()
    .max(100, "Fee paid by must be at most 100 characters")
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  chequeDate: Yup.string()
    .optional()
    .trim("No white space allowed")
    .strict(true)
    .when("chequeOrUTRNo", {
      is: (val) => val && val.trim().length > 0, // Check if chequeOrUTRNo is not null or empty
      then: Yup.string().required(
        "Cheque date is required."
      ),
      otherwise: Yup.string().optional(),
    }),
  receiptDate: customDateValidation(
    "Receipt date is required",
    "receiptDate"
  ),
});
const FeeReceipt = () => {
  const theme = useTheme();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [showSubFeeFor, setShowSubFeeFor] = useState(false);
  const [receiptId, setReceiptId] = useState("");
  const [receiptGrid, setReceiptGrid] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pdfData, setPdfData] = useState(false);
  const [emailPDFSending, setEmailPDFSending] = useState(false);
  const [showFields, setShowField] = useState(true);
  const [file, setFile] = useState({ pdf: "" });
  const [feeTypeArray, setFeeTypeArray] = useState([]);
  const [feeYearDD, setYearFeeDD] = useState();
  const [feeForFieldValue, setFeeForFieldValue] = useState();
  const [feeForData, setFeeForData] = useState(null);
  const [feeTypeData, setFeeTypeData] = useState(null);
  const [memberNameDD, setMemberNameDD] = useState(null);
  const [memberList, setMemberList] = useState([]);
  const [isDropdown, setIsDropdown] = useState(false);
  const [disableFeeYear, setDisableFeeYear] = useState(false);
  const [paymentModeData, setPaymentModeData] = useState(null);
  const [feeYearData, setFeeYearData] = useState(null);
  const [subFeeForData, setSubFeeForData] = useState(null);
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const [emailData, setEmailData] = useState(false);
  const [loader, setLoader] = useState(true);
  const [subFeeForValue, setSubFeeForValue] = useState();
  const feeReceiptController = new FeeReceiptController();
  const masterController = new MasterController();
  const exceptionHandlerController = new ExceptionHandlerController();
  // const { userid: tenantId } = data.UserInfo;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const colors = tokens(theme.palette.mode);
  const [popup, setPopUp] = useState(false);
  const [popup1, setPopUp1] = useState(false);
  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  React.useEffect(() => {
    getReceiptGrid();
    getMastersFeeYear("");
    getMastersFeeFor("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { headerName: "Id", field: "receiptId", hide: true, filterable: false },
    { headerName: "Name of Member", field: "memberName", width: 250 },
    { headerName: "Receipt No", field: "receiptNo", width: 200 },
    { headerName: "Purpose", field: "feefor", width: 200 },
    {
      headerName: "Create Date",
      field: "createdDate",
      width: 150,
      type: "date",
      valueGetter: (params) => {
        if (!params.value) return null;

        // Convert MM/DD/YYYY to DD/MM/YYYY format
        const dateObj = new Date(params.value);
        const day = dateObj.getDate().toString().padStart(2, "0");
        const month = (dateObj.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
        const year = dateObj.getFullYear();

        return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
      },
      sortComparator: (date1, date2) => {
        const [d1, m1, y1] = date1.split("/").map(Number);
        const [d2, m2, y2] = date2.split("/").map(Number);
        return y1 - y2 || m1 - m2 || d1 - d2; // Sorts by Year -> Month -> Day
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      sortable: false,
      disableExport: true,
      filterable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        const onClick = (e, type) => {
          let caughtError;
          try {
            setAlert({ counter: 0, type: "", msg: "" });
            const currentRow = params.row;
            if (type === "Edit") {
              setShowField(true);
              setUpdatedValues();
              setLoader(() => true);
              setIsDropdown(false);
              setFeeForData(null);
              setFeeYearData(null);
              setSubFeeForData(null);
              setFeeTypeData(null);
              setReceiptId();
              let tempData = {};
              setFile({ pdf: "" });
              feeReceiptController
                .GetReceiptId(currentRow.id, token)
                .then((resultObj) => {
                  const responseData = resultObj?.data?.body ?? {};
                  getMastersFeeYear(responseData?.feeYear);
                  getMastersFeeFor(responseData?.feefor);
                  if (resultObj.status === 200) {
                    tempData = {
                      memberName: responseData?.memberName ?? "",
                      email: responseData?.email ?? "",
                      mobileNumber: responseData?.mobileNumber.toString() ?? "",
                      feePaidBy: responseData?.feePaidBy ?? "",
                      feeYear: responseData?.feeYear ?? "",
                      feefor: responseData?.feefor ?? "",
                      memberId: responseData?.memberId ?? "",
                      subfeefor: responseData?.subfeefor ?? "",
                      remarks: responseData?.remarks ?? "",
                      feeType: responseData?.feeType ?? "",
                      amount: responseData?.amount ?? "",
                      paymentMode: responseData?.paymentMode ?? "",
                      chequeOrUTRNo: responseData?.chequeOrUTRNo ?? "",
                      chequeDate: responseData?.chequeDate ?? "",
                      receiptDate: responseData?.receiptDate ?? "",
                    };
                    setUpdatedValues(tempData);
                    setPaymentModeData({
                      label: responseData?.paymentMode,
                      value: responseData?.paymentMode,
                    });
                    if (responseData?.feeType) {
                      setFeeTypeData({
                        label: responseData?.feeType,
                        value: responseData?.feeType,
                      });
                    }

                    handlefeeType(responseData?.memberShip);
                    setReceiptId(responseData?.receiptId);
                    fetch(responseData?.PDF)
                      .then((res) => res?.blob())
                      .then((blob) =>
                        setFile((prev) => ({ ...prev, pdf: blob }))
                      );
                    if (
                      responseData.subfeefor !==
                      process.env.REACT_APP_OTHERS_RECEIPT
                    ) {
                      getMastersSubFeeFor(
                        responseData?.feefor,
                        responseData?.subfeefor
                      );
                    }
                    setShowSubFeeFor(true);
                    setPdfData(true);
                    if (responseData?.email) {
                      if (
                        responseData?.email &&
                        emailRegex.test(responseData?.email)
                      ) {
                        setEmailData(true);
                      } else {
                        setEmailData(false);
                      }
                    }
                    setLoader(() => false);
                  } else {
                    showAlert("error", resultObj?.response?.data?.message);
                  }
                });
              handleData();
            } else {
              feeReceiptController
                .DeleteReceiptById(currentRow.id, token)
                .then((resultObj) => {
                  if (resultObj.status === 200) {
                    showAlert("success", "Deleted successfully");
                    getReceiptGrid();
                  } else {
                    showAlert("error", resultObj?.response?.data?.message);
                  }
                });
            }
          } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
              logData,
              module: "service page onClick(Edit) method",
            };
            exceptionHandlerController.HandleException(logError);
          }
        };

        return (
          <Stack direction="row" spacing={1}>
            <>
              <IconButton>
                <EditIcon
                  type="button"
                  color="primary"
                  id="Edit"
                  onClick={(e) => onClick(e, "Edit")}
                />
              </IconButton>
              <IconButton>
                <DeleteIcon
                  type="button"
                  color="primary"
                  id="Delete"
                  onClick={(e) => onClick(e, "Delete")}
                />
              </IconButton>
            </>
          </Stack>
        );
      },
    },
  ];

  const handleMemberNameChange = (event, setFieldValue) => {
    const value = event?.target?.value;
    setFieldValue("memberName", value);
  };

  const handleDownloadPDF = () => {
    const fileName = `Fee Receipt.pdf`;
    downloadPDF({
      file: file?.pdf,
      showAlert,
      fileName,
    });
  };

  const handleSearchClick = (values) => {
    const memberName = values.memberName;
    if (memberName) {
      handleMemberData(memberName);
    } else {
      showAlert("error", "Please input the member name field");
    }
  };

  const handleSendPDFMail = () => {
    setEmailPDFSending(true);
    if (emailData) {
      sendPDFMail();
    }
  };

  const handleReceiptDateChange = (e, setFieldTouched, setFieldValue) => {
    setFieldTouched("receiptDate", true);
    const formattedDate = moment(new Date(e)).format("DD/MM/YYYY");
    setFieldValue("receiptDate", formattedDate);
  };

  const handleChequeDateChange = (e, setFieldTouched, setFieldValue) => {
    setFieldTouched("chequeDate", true);
    const formattedDate = moment(new Date(e)).format("DD/MM/YYYY");
    setFieldValue("chequeDate", formattedDate);
  };

  const handleFeeForChange = (value, setFieldValue) => {
    resetFields(setFieldValue);
    if (value) {
      setFieldValue("feefor", value.value);
      setFieldValue("selectedfeeforDD", value);
      handlefeeType(value.label);
      getMastersSubFeeFor(value.value, "");
      const isOthersReceipt =
        value.value === process.env.REACT_APP_OTHERS_RECEIPT;
      setShowSubFeeFor(!isOthersReceipt);
      setFeeForData(value);
    }
  };

  const handleMemberList = (id) => {
    setUpdatedValues();
    setFeeForData(null);
    setFeeTypeData(null);
    setFeeYearData(null);
    setSubFeeForData(null);
    setReceiptId();
    let caughtError;
    try {
      const memberdata = memberList.filter(
        (value) => id === value?.memberId
      )[0];
      const tempData = {
        memberName: memberdata?.memberFullName ?? "",
        email: memberdata?.emailID ?? "",
        mobileNumber: memberdata?.mobileNumber.toString() ?? "",
        feefor: memberdata?.feeFor ?? "",
        subfeefor: memberdata?.subfeefor ?? "",
      };
      setUpdatedValues(tempData);
      setShowField(false);
      if (memberdata?.feeFor) {
        getMastersFeeFor(memberdata?.feeFor);
      }
      if (memberdata?.memberType) {
        setFeeTypeData({
          label: memberdata?.memberType,
          value: memberdata?.memberType,
        });
      }
      setShowSubFeeFor(true);
      getMastersSubFeeFor(memberdata?.feeFor, memberdata?.subfeefor);
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "feeReceipt handleMemberList method" };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const handleSubFeeForChange = (value, setFieldValue) => {
    if (value) {
      setFieldValue("subfeefor", value?.value);
      handlefeeType(value?.label);
      setFieldValue("selectedSubfeeforDD", value);
    }
    setSubFeeForData(value);
  };

  const handleEmailChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue("email", value);
    setEmailData(!!(value && emailRegex.test(value)));
  };
  const handleMobileChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue("mobileNumber", value.toString());
    // setEmailData(!!(value && emailRegex.test(value)));
  };

  const handleMemberData = (value) => {
    setMemberNameDD([]);
    let caughtError;
    try {
      feeReceiptController
        .GetMemberData(value, token)
        .then((resultObj) => {
          const fetchedFamilyNameDD = [];
          if (resultObj.status === 200) {
            setIsDropdown(true);
            const memberName = resultObj?.data?.body;
            if (memberName.length === 0) {
              setIsDropdown(false);
            }
            setMemberList(memberName);
            memberName?.forEach((item) => {
              if (item && item.memberFullName && item.memberId) {
                fetchedFamilyNameDD.push({
                  label: item.memberFullName,
                  value: item.memberId,
                });
              }
            });
          } else if (resultObj?.response?.data?.status) {
            showAlert("error", resultObj?.response?.data?.message);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
          setMemberNameDD(fetchedFamilyNameDD);
          return fetchedFamilyNameDD;
        })
        .catch((error) => {
          showAlert("error", "An error occurred while fetching member data.");
          return [];
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "feeReceipt handleMemberData method" };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const sendPDFMail = () => {
    let caughtError;
    try {
      const id = receiptId;
      feeReceiptController.SendPDFMail(id, token).then((response) => {
        setEmailPDFSending(false);
        if (response.status === 200) {
          getReceiptGrid();
          showAlert("success", response?.data?.message);
        } else {
          showAlert("error", response?.response?.data?.message);
        }
      });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "feeReceipt page sendPDFMail method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const submitValues = (values) => {
    let caughtError;
    if (isSubmitting) return;
    setIsSubmitting(true);
    const filteredData = {};
    for (let key in values) {
      if (
        values[key] !== "" &&
        !key.startsWith(":") &&
        typeof values[key] !== "object" &&
        values[key] !== null
      ) {
        filteredData[key] = values[key];
      }
    }
    if (receiptId) {
      filteredData.receiptId = receiptId;
    }
    try {
      filteredData.tenantId = tenantId;
      feeReceiptController
        .CreateReceipt(filteredData, token)
        .then((resultObj) => {
          setEmailData(false);
          setIsSubmitting(false);
          if (resultObj.status === 201) {
            setDisableFeeYear(true);
            const serverResponse = resultObj?.data?.body;
            setReceiptId(serverResponse?.result?._id);
            if (serverResponse?.PDF) {
              setPdfData(true);
              fetch(serverResponse?.PDF)
                .then((res) => res?.blob())
                .then((blob) => setFile((prev) => ({ ...prev, pdf: blob })));
            }
            if (serverResponse?.result?.email || serverResponse?.result?.mobileNumber) {
              setEmailData(true);
            }
            getReceiptGrid();
            showAlert("success", resultObj?.data?.message);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "feeReceipt page submitValues method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const handlePopup = (value) => setPopUp(value);
  const handleData = () => setPopUp(true);
  const handlePopup1 = (value) => {
    setPopUp1(value);
    setDisableFeeYear(false);
  }
  const handleData1 = () => setPopUp1(true);

  const getReceiptGrid = () => {
    let caughtError;
    try {
      feeReceiptController
        .GetGridData(token)
        .then((resultObj) => {
          setLoader(() => false);
          if (resultObj.status === 200) {
            const userData = resultObj?.data?.body?.map((item) => {
              const { receiptId: id, ...rest } = item;
              return { id, ...rest };
            });
            setReceiptGrid(() => userData);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        })
        .catch((error) => {
          caughtError = error;
          let logData = {};
          logData.message = caughtError?.message;
          logData.stack = caughtError?.stack;
          let logError = {
            logData,
            module: "feeReceipt page getReceiptGrid inside method",
          };
          exceptionHandlerController.HandleException(logError);
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "feeReceipt page getReceiptGrid method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const PaymentModeDD = [
    { label: "Cash", value: "Cash" },
    { label: "Cheque", value: "Cheque" },
    { label: "Online", value: "Online" },
  ];

  const memberShipData = [
    { label: "Primary Member", value: "Primary Member" },
    { label: "Family Member", value: "Family Member" },
    { label: "Leo Lion Member", value: "Leo Lion Member" },
  ];
  const nonMemberShipData = [
    { label: "Entrance Fee", value: "Entrance Fee" },
    { label: "Other Fee", value: "Other Fee" },
  ];
  const activitiesData = [{ label: "Activity", value: "Activity" }];

  const handlefeeType = (type) => {
    setFeeTypeArray([]);
    if (type === "Membership") {
      setFeeTypeArray(memberShipData);
    } else if (type === "Others") {
      setFeeTypeArray(nonMemberShipData);
    } else if (type === "Activity") {
      setFeeTypeArray(activitiesData);
    } else {
      setFeeTypeArray([]);
    }
  };

  const resetFields = (setFieldValue) => {
    setFieldValue("feeType", ""); // Reset feeType to an empty string
    setFieldValue("selectedFeeType", null); // Reset selectedFeeType
    setFieldValue("subfeefor", "");
    setFieldValue("selectedSubfeeforDD", null); // Reset selectedSubfeeforDD
    setFeeTypeArray([]); // Clear the feeTypeArray
  };

  const getMastersFeeYear = (feeYearId) => {
    let caughtError;

    masterController
      .GetMastersFeeYear()
      .then((resultObj) => {
        if (resultObj.status === 200) {
          const result = resultObj?.data?.body;
          const fetchedFeeData = result.map((item) => ({
            label: item?.year,
            value: item?._id,
          }));
          setYearFeeDD(fetchedFeeData);
          if (feeYearId) {
            const fetchedResponseFee = result.filter(
              (item) => item._id === feeYearId
            );
            const { year, _id } = fetchedResponseFee[0];
            const filteredObject = { label: year, value: _id };
            setFeeYearData(filteredObject);
          }
        } else {
          showAlert("error", resultObj?.response?.data?.message);
        }
      })
      .catch((error) => {
        caughtError = error;
        let logData = {};
        logData.message = caughtError?.message;
        logData.stack = caughtError?.stack;
        let logError = {
          logData,
          module: "feeReceipt getMastersFeeYear inside method",
        };
        exceptionHandlerController.HandleException(logError);
      });
  };
  const getMastersFeeFor = (feeId) => {
    masterController
      .GetMastersFeeFor()
      .then((resultObj) => {
        if (resultObj.status === 200) {
          const result = resultObj?.data?.body;
          const fetchedFeeData = result.map((item) => ({
            label: item?.valueFor,
            value: item?._id,
          }));

          setFeeForFieldValue(fetchedFeeData);

          if (feeId) {
            const fetchedResponseFee = result.find(
              (item) => item._id === feeId
            );
            if (fetchedResponseFee) {
              const { valueFor, _id } = fetchedResponseFee;
              const filteredObject = { label: valueFor, value: _id };
              setFeeForData(filteredObject);
            }
          }
        } else {
          showAlert("error", resultObj?.response?.data?.message);
        }
      })
      .catch(handleErrorGetMastersFeeFor);
  };

  const handleErrorGetMastersFeeFor = (error) => {
    let logData = {
      message: error?.message,
      stack: error?.stack,
    };
    let logError = {
      logData,
      module: "feeReceipt handleErrorGetMastersFeeFor method",
    };
    exceptionHandlerController.HandleException(logError);
  };

  const getMastersSubFeeFor = (id, subFeeId) => {
    let caughtError;
    try {
      masterController
        .GetMastersSubFeeFor(id)
        .then((resultObj) => {
          setLoader(() => false);
          if (resultObj.status === 200) {
            const result = resultObj?.data?.body;
            const fetchedFeeData = result.map((item) => ({
              label: item?.feeForValue,
              value: item?._id,
            }));
            setSubFeeForValue(fetchedFeeData);
            if (subFeeId) {
              const fetchedResponseFee = result.filter(
                (item) => item._id === subFeeId
              );
              const { feeForValue, feeForId } = fetchedResponseFee[0];
              const filteredObject = { label: feeForValue, value: feeForId };
              setSubFeeForData(filteredObject);
            }
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        })
        .catch((error) => {
          caughtError = error;
          let logData = {};
          logData.message = caughtError?.message;
          logData.stack = caughtError?.stack;
          let logError = {
            logData,
            module: "feeReceipt getMastersSubFeeFor inside method",
          };
          exceptionHandlerController.HandleException(logError);
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "feeReceipt getMastersSubFeeFor method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const AddRecipt = (e) => {
    setIsDropdown(false);
    setShowField(true);
    setUpdatedValues();
    setReceiptId();
    setFeeForData(null);
    setFeeYearData(null);
    setFeeTypeData(null);
    setSubFeeForData(null);
    setPdfData(false);
    setEmailData(false);
    handleData1();
  };
  if (loader) return <Load />;
  return (
    <Box
      sx={{
        "& .formBg": {
          border: `1px solid ${colors.grey[900]}`,
          background: `${colors.primary[400]}`,
        },
        "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
        "& .MuiGrid-root.Mui-heading h2": {
          color: `${colors.primary[200]} !important`,
        },
      }}
    >
      <Grid container>
        <Grid className="breadcrumb-section">
          <Grid className="breadcrumb-container">
            <Grid className="Mui-li">
              <nav className="Mui-nav" aria-label="breadcrumb">
                <ol className="">
                  <li className="MuiBreadcrumbs-li">
                    <h6 className="breadsub">Membership</h6>
                  </li>
                  <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                    /
                  </li>
                  <li className="MuiBreadcrumbs-li">
                    <h6>Fee Receipt</h6>
                  </li>
                </ol>
              </nav>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} className="adduser au1 pt-2">
          <Controls.ActionButton onClick={AddRecipt}>
            Generate Invoice
          </Controls.ActionButton>
        </Grid>
        <Grid item xs={12} className="formBg">
          <Container maxWidth="md" className="formClwidth">
            <div>
              <Controls.Grid
                columns={columns}
                data={receiptGrid}
                fileName={"Receipt"}
              />
              {popup && (
                <Controls.Popup
                  title="Edit Fee Receipt"
                  openPopup={popup}
                  setOpenPopup={handlePopup}
                >
                  <Container maxWidth="md" className="formClwidth">
                    <div>
                      <Formik
                        enableReinitialize
                        initialValues={{
                          ...(updatedValues || INITIAL_FORM_STATE),
                        }}
                        validationSchema={FORM_VALIDATION}
                        onSubmit={(values) => submitValues(values)}
                      >
                        {({
                          values,
                          setFieldValue,
                          handleChange,
                          setFieldTouched,
                        }) => (
                          <React.Fragment>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={5}>
                                {isDropdown ? (
                                  <Controls.AutoComplete
                                    name="memberName"
                                    label={
                                      <span>
                                        Member name{" "}
                                        <span className="asterisk">*</span>
                                      </span>
                                    }
                                    options={memberNameDD}
                                    type="string"
                                    onChange={(event, value) => {
                                      if (value) {
                                        setFieldValue(
                                          "memberNameId",
                                          value?.value
                                        );
                                        setFieldValue(
                                          "memberName",
                                          value?.label
                                        );
                                        setFieldValue(
                                          "selectedDDMemberName",
                                          value
                                        );
                                        handleChange(event);
                                      } else {
                                        setFieldValue(
                                          "memberName",
                                          event?.target?.value
                                        );
                                      }
                                    }}
                                  />
                                ) : (
                                  <Controls.Textfield
                                    name="memberName"
                                    label={
                                      <span>
                                        Member name{" "}
                                        <span className="asterisk">*</span>
                                      </span>
                                    }
                                    onChange={(e) =>
                                      handleMemberNameChange(e, setFieldValue)
                                    }
                                  />
                                )}
                              </Grid>
                              <Grid item xs={12} md={1}>
                                <SearchIcon
                                  className="btn-save"
                                  onClick={() => {
                                    handleSearchClick(values);
                                  }}
                                />
                              </Grid>
                              {/* {showFields && ( */}
                              <>
                                <Grid item xs={12} md={6}>
                                  <Controls.AutoComplete
                                    name="feefor"
                                    value={feeForData}
                                    label={
                                      <span>
                                        Fee For{" "}
                                        <span className="asterisk">*</span>
                                      </span>
                                    }
                                    type="string"
                                    options={feeForFieldValue}
                                    onChange={(event, value) =>
                                      handleFeeForChange(value, setFieldValue)
                                    }
                                  />
                                </Grid>

                                {showSubFeeFor && (
                                  <Grid item xs={12} md={6}>
                                    <Controls.AutoComplete
                                      name="subfeefor"
                                      label="Purpose"
                                      type="string"
                                      value={subFeeForData}
                                      options={subFeeForValue}
                                      onChange={(evt, value) =>
                                        handleSubFeeForChange(
                                          value,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  </Grid>
                                )}
                              </>
                              {/*  )} */}
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="feePaidBy"
                                  label="Fee paid by"
                                  type="string"
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>
                              {/* {showFields && ( */}
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="email"
                                  label="E-mail"
                                  type="string"
                                  inputProps={{ maxLength: 150 }}
                                  onChange={(e) =>
                                    handleEmailChange(e, setFieldValue)
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="mobileNumber"
                                  label="Mobile Number"
                                  type="string"
                                  inputProps={{ maxLength: 10 }}
                                  onChange={(e) =>
                                    handleMobileChange(e, setFieldValue)
                                  }
                                />
                              </Grid>
                              {/* )} */}
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="feeYear"
                                  label={
                                    <span>
                                      Fee year{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  disabled={true}
                                  value={feeYearData}
                                  options={feeYearDD}
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue("feeYear", value?.value);
                                      setFieldValue("feeYearSelected", value);
                                      setFeeYearData(value);
                                    }
                                    handleChange(event);
                                  }}
                                  onBlur={(event) => {
                                    const matchedOption = feeYearDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (matchedOption) {
                                      setFieldValue("feeYear", matchedOption.value);
                                      setFieldValue("feeYearSelected", matchedOption);
                                      setFeeYearData(matchedOption);
                                    } else {
                                      // Clear fields if input doesn't match any option
                                      setFieldValue("feeYear", "");
                                      setFieldValue("feeYearSelected", null);
                                      setFeeYearData(null);
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              {/* {showFields && ( */}
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="feeType"
                                  label="Fee type"
                                  type="string"
                                  value={feeTypeData}
                                  options={feeTypeArray}
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue("feeType", value?.value);
                                      setFieldValue("selectedFeeType", value);
                                      setFeeTypeData(value);
                                    }
                                    handleChange(event);
                                  }}
                                />
                              </Grid>
                              {/* )} */}

                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="amount"
                                  label={
                                    <span>
                                      Amount <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                />
                              </Grid>

                              <Grid item xs={12} md={12}>
                                <Controls.Textfield
                                  name="remarks"
                                  label="Remarks"
                                  type="string"
                                  inputProps={{ maxLength: 30 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={12}>
                                <b>Payment</b>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="paymentMode"
                                  label={
                                    <span>
                                      Payment mode{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  value={paymentModeData}
                                  options={PaymentModeDD}
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue("paymentMode", value.value);
                                      setFieldValue(
                                        "selectedPaymentMode",
                                        value
                                      );
                                      setPaymentModeData(value);
                                    }
                                    handleChange(event);
                                  }}
                                />
                              </Grid>
                              {values?.paymentMode !== "Cash" && (
                                <>
                                  <Grid item xs={12} md={6}>
                                    <Controls.Textfield
                                      name="chequeOrUTRNo"
                                      label="Cheque no / UTR"
                                      type="string"
                                      inputProps={{ maxLength: 20 }}
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <Controls.DateTimePicker
                                      name="chequeDate"
                                      label={
                                        values?.chequeOrUTRNo ? (
                                          <span>
                                            Cheque date <span className="asterisk">*</span>
                                          </span>
                                        ) : (
                                          "Cheque date"
                                        )
                                      }
                                      type="string"
                                      // disableFuture={true}
                                      value={
                                        values?.chequeDate
                                          ? dayjs(values?.chequeDate, "DD/MM/YYYY")
                                          : null
                                      }
                                      onChange={(e) => {
                                        setFieldTouched("chequeDate", true);
                                        setFieldValue(
                                          "chequeDate",
                                          moment(new Date(e))?.format("DD/MM/YYYY")
                                        );
                                      }}
                                    />
                                  </Grid>
                                </>
                              )}
                              <Grid item xs={12} md={6}>
                                <Controls.DateTimePicker
                                  name="receiptDate"
                                  label={
                                    <span>
                                      Receipt date{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  disableFuture={true}
                                  value={
                                    values?.receiptDate
                                      ? dayjs(values?.receiptDate, "DD/MM/YYYY")
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleReceiptDateChange(
                                      e,
                                      setFieldTouched,
                                      setFieldValue
                                    )
                                  }
                                />
                              </Grid>

                              <Grid item xs={12}>
                                <Grid item xs={4} md={2} className="marginAuto">
                                  {isSubmitting ? (
                                    <img
                                      src={PDFLoader}
                                      width={57}
                                      alt="Loading"
                                      style={{ marginLeft: "7px" }}
                                    />
                                  ) : (
                                    <Controls.Button >Submit</Controls.Button>
                                  )}
                                </Grid>
                              </Grid>
                              {pdfData && (
                                <>
                                  <Grid item xs={12} md={3}>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                    <a onClick={handleDownloadPDF}>
                                      <img
                                        src={PDF}
                                        width={40}
                                        alt="pdf"
                                        style={{
                                          marginLeft: "17px",
                                          cursor: "pointer",
                                        }}
                                      />
                                      <span
                                        className="esigntext"
                                        style={{ display: "flex" }}
                                      >
                                        Download PDF
                                      </span>
                                    </a>
                                  </Grid>

                                  <Grid item xs={12} md={3}>
                                    {(!emailPDFSending) ? (
                                      <>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                        <a
                                          onClick={handleSendPDFMail}
                                          style={{
                                            cursor: emailData
                                              ? "pointer"
                                              : "not-allowed",
                                            pointerEvents: emailData
                                              ? "auto"
                                              : "none",
                                            opacity: emailData ? 1 : 0.5,
                                          }}
                                        >
                                          <img
                                            src={PDF}
                                            width={37}
                                            alt="pdf"
                                            style={{ marginLeft: "7px" }}
                                          />
                                          <span
                                            className="esigntext"
                                            style={{ display: "flex" }}
                                          >
                                            Send PDF
                                          </span>
                                        </a>
                                      </>
                                    ) : (
                                      <>
                                        <img
                                          src={PDFLoader}
                                          width={57}
                                          alt="pdf"
                                          style={{ marginLeft: "7px" }}
                                        />
                                        <span
                                          className="esigntext"
                                          style={{ display: "flex" }}
                                        >
                                          Sending PDF
                                        </span>
                                      </>
                                    )}
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          </React.Fragment>
                        )}
                      </Formik>
                    </div>
                  </Container>
                </Controls.Popup>
              )}

              {popup1 && (
                <Controls.Popup
                  title="Generate Fee Receipt"
                  minHeight={100}
                  openPopup={popup1}
                  setOpenPopup={handlePopup1}
                >
                  <Container maxWidth="md" className="formClwidth">
                    <div>
                      <Formik
                        enableReinitialize
                        initialValues={{
                          ...(updatedValues || INITIAL_FORM_STATE),
                        }}
                        validationSchema={FORM_VALIDATION}
                        onSubmit={(values) => submitValues(values)}
                      >
                        {({
                          values,
                          setFieldValue,
                          handleChange,
                          setFieldTouched,
                        }) => (
                          <React.Fragment>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={5}>
                                {isDropdown ? (
                                  <Controls.AutoComplete
                                    name="memberName"
                                    label={
                                      <span>
                                        Member name{" "}
                                        <span className="asterisk">*</span>
                                      </span>
                                    }
                                    options={memberNameDD}
                                    type="string"
                                    onChange={(event, value) => {
                                      if (value) {
                                        setFieldValue(
                                          "memberName",
                                          value?.value
                                        );
                                        setFieldValue(
                                          "selectedDDMemberName",
                                          value
                                        );
                                        handleMemberList(value?.value);
                                      }
                                      handleChange(event);
                                    }}
                                  />
                                ) : (
                                  <Controls.Textfield
                                    name="memberName"
                                    label={
                                      <span>
                                        Member name{" "}
                                        <span className="asterisk">*</span>
                                      </span>
                                    }
                                    onChange={(event) => {
                                      setFieldValue(
                                        "memberName",
                                        event?.target?.value
                                      );
                                    }}
                                  />
                                )}
                              </Grid>
                              <Grid item xs={12} md={1}>
                                <SearchIcon
                                  className="btn-save"
                                  onClick={() => {
                                    handleSearchClick(values);
                                  }}
                                />
                              </Grid>
                              {/* {showFields && ( */}
                              <>
                                <Grid item xs={12} md={6}>
                                  <Controls.AutoComplete
                                    name="feefor"
                                    value={feeForData}
                                    label={
                                      <span>
                                        Fee For{" "}
                                        <span className="asterisk">*</span>
                                      </span>
                                    }
                                    type="string"
                                    options={feeForFieldValue}
                                    onChange={(event, value) =>
                                      handleFeeForChange(value, setFieldValue)
                                    }
                                  />
                                </Grid>

                                {showSubFeeFor && (
                                  <Grid item xs={12} md={6}>
                                    <Controls.AutoComplete
                                      name="subfeefor"
                                      label="Purpose"
                                      type="string"
                                      value={subFeeForData}
                                      options={subFeeForValue}
                                      onChange={(evt, value) =>
                                        handleSubFeeForChange(
                                          value,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  </Grid>
                                )}
                              </>
                              {/* )} */}

                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="feePaidBy"
                                  label="Fee paid by"
                                  type="string"
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>
                              {/* {showFields && ( */}
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="email"
                                  label="E-mail"
                                  type="string"
                                  value={values.email || ""}
                                  inputProps={{ maxLength: 150 }}
                                  onChange={(e) =>
                                    handleEmailChange(e, setFieldValue)
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="mobileNumber"
                                  label="Mobile Number"
                                  type="string"
                                  value={values.mobileNumber.toString() || ""}
                                  inputProps={{ maxLength: 10 }}
                                  onChange={(e) =>
                                    handleMobileChange(e, setFieldValue)
                                  }
                                />
                              </Grid>

                              {/* )} */}
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="feeYear"
                                  label={
                                    <span>
                                      Fee year{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  value={feeYearData}
                                  disabled={disableFeeYear}
                                  options={feeYearDD}
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue("feeYear", value?.value);
                                      setFieldValue("feeYearSelected", value);
                                      setFeeYearData(value);
                                    }
                                    handleChange(event);
                                  }}
                                  onBlur={(event) => {
                                    const matchedOption = feeYearDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (matchedOption) {
                                      setFieldValue("feeYear", matchedOption.value);
                                      setFieldValue("feeYearSelected", matchedOption);
                                      setFeeYearData(matchedOption);
                                    } else {
                                      // Clear fields if input doesn't match any option
                                      setFieldValue("feeYear", "");
                                      setFieldValue("feeYearSelected", null);
                                      setFeeYearData(null);
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              {/* {showFields && ( */}
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="feeType"
                                  label="Fee type"
                                  type="string"
                                  value={feeTypeData}
                                  options={feeTypeArray}
                                  onChange={(event, value) => {
                                    setFieldValue("feeType", value?.value);
                                    setFieldValue("selectedFeeType", value);
                                    setFeeTypeData(value);
                                    handleChange(event);
                                  }}
                                />
                              </Grid>
                              {/* )} */}
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="amount"
                                  label={
                                    <span>
                                      Amount <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                />
                              </Grid>

                              <Grid item xs={12} md={12}>
                                <Controls.Textfield
                                  name="remarks"
                                  label="Remarks"
                                  type="string"
                                  inputProps={{ maxLength: 30 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={12}>
                                <b>Payment</b>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="paymentMode"
                                  label={
                                    <span>
                                      Payment mode{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  options={PaymentModeDD}
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "paymentMode",
                                        value?.value
                                      );
                                      setFieldValue(
                                        "selectedPaymentMode",
                                        value
                                      );
                                    }
                                  }}
                                />
                              </Grid>
                              {values?.paymentMode !== "Cash" && (
                                <>
                                  <Grid item xs={12} md={6}>
                                    <Controls.Textfield
                                      name="chequeOrUTRNo"
                                      label="Cheque no / UTR"
                                      type="string"
                                      inputProps={{ maxLength: 20 }}
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <Controls.DateTimePicker
                                      name="chequeDate"
                                      label={
                                        values?.chequeOrUTRNo ? (
                                          <span>
                                            Cheque date <span className="asterisk">*</span>
                                          </span>
                                        ) : (
                                          "Cheque date"
                                        )
                                      }
                                      // disableFuture={true}
                                      value={
                                        values?.chequeDate
                                          ? dayjs(values?.chequeDate, "DD/MM/YYYY")
                                          : null
                                      }
                                      onChange={(e) =>
                                        handleChequeDateChange(
                                          e,
                                          setFieldTouched,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  </Grid>
                                </>)}
                              <Grid item xs={12} md={6}>
                                <Controls.DateTimePicker
                                  name="receiptDate"
                                  label={
                                    <span>
                                      Receipt date{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  value={
                                    values?.receiptDate
                                      ? dayjs(values?.receiptDate, "DD/MM/YYYY")
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleReceiptDateChange(
                                      e,
                                      setFieldTouched,
                                      setFieldValue
                                    )
                                  }
                                />
                              </Grid>

                              <Grid item xs={12}>
                                <Grid item xs={4} md={2} className="marginAuto">
                                  {isSubmitting ? (
                                    <img
                                      src={PDFLoader}
                                      width={57}
                                      alt="Loading"
                                      style={{ marginLeft: "7px" }}
                                    />
                                  ) : (
                                    <Controls.Button >Submit</Controls.Button>
                                  )}
                                </Grid>
                              </Grid>
                              {pdfData && (
                                <>
                                  <Grid item xs={12} md={3}>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                    <a onClick={handleDownloadPDF}>
                                      <img
                                        src={PDF}
                                        width={40}
                                        alt="pdf"
                                        style={{
                                          marginLeft: "17px",
                                          cursor: "pointer",
                                        }}
                                      />
                                      <span
                                        className="esigntext"
                                        style={{ display: "flex" }}
                                      >
                                        Download PDF
                                      </span>
                                    </a>
                                  </Grid>

                                  <Grid item xs={12} md={3}>
                                    {!emailPDFSending ? (
                                      <>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                        <a
                                          onClick={handleSendPDFMail}
                                          style={{
                                            cursor: emailData
                                              ? "pointer"
                                              : "not-allowed",
                                            pointerEvents: emailData
                                              ? "auto"
                                              : "none",
                                            opacity: emailData ? 1 : 0.5,
                                          }}
                                        >
                                          <img
                                            src={PDF}
                                            width={37}
                                            alt="pdf"
                                            style={{ marginLeft: "7px" }}
                                          />
                                          <span
                                            className="esigntext"
                                            style={{ display: "flex" }}
                                          >
                                            Send PDF
                                          </span>
                                        </a>
                                      </>
                                    ) : (
                                      <>
                                        <img
                                          src={PDFLoader}
                                          width={57}
                                          alt="pdf"
                                          style={{ marginLeft: "7px" }}
                                        />
                                        <span
                                          className="esigntext"
                                          style={{ display: "flex" }}
                                        >
                                          Sending PDF
                                        </span>
                                      </>
                                    )}
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          </React.Fragment>
                        )}
                      </Formik>
                    </div>
                  </Container>
                </Controls.Popup>
              )}

              {file?.pdfUrl && pdfData?.showIframe && (
                <iframe
                  src={file?.pdfUrl}
                  title="PDF Viewer"
                  width="100%"
                  height="500px"
                  style={{ border: "none", marginTop: "20px" }}
                ></iframe>
              )}
            </div>
          </Container>
        </Grid>
      </Grid>
      {
        alert.counter > 0 && (
          <CustomizedSnackbars
            status={alert.counter}
            msg={alert.msg}
            type={alert.type}
          />
        )
      }
    </Box >
  );
};

export default FeeReceipt;
